import { motion } from "framer-motion";
import { Coffee, MapPin, Pencil, Bike } from "lucide-react";
import { IMG } from "@/lib/images";

const MOMENTS = [
  { icon: Coffee, label: "Greek Coffee" },
  { icon: Pencil, label: "Sketching" },
  { icon: MapPin, label: "Coastal Roads" },
  { icon: Bike, label: "Riding" },
];

export const GreeceInspiration = () => {
  return (
    <section id="greece" data-testid="greece-section" className="relative py-28 md:py-40 bg-[#0A0A0C] overflow-hidden">
      {/* Background blurred coast shot */}
      <div className="absolute inset-0">
        <img
          src={IMG.RIDE_COAST}
          alt=""
          className="w-full h-full object-cover blur-md opacity-25"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0C]/95 via-[#0A0A0C]/55 to-[#0A0A0C]/25" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0C] via-transparent to-[#0A0A0C]/10" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="lg:col-span-7"
        >
          <div className="flex items-center gap-3 mb-6">
            <span className="section-mark" />
            <span className="overline">Where the design lives · Greece</span>
          </div>
          <h2 className="h-section text-white text-4xl sm:text-5xl lg:text-6xl">
            Some ideas don&apos;t come <br />
            from an office. <br />
            <span className="text-[#F47A20]">They come from the road.</span>
          </h2>
          <p className="mt-8 text-white/75 text-base sm:text-lg leading-relaxed max-w-xl">
            Coastal mornings. A second coffee. A notebook half-filled with arrows and arguments. ROADRIG breathes between rides — and a lot of it breathes in Greece.
          </p>

          <div className="mt-10 flex flex-wrap gap-3">
            {MOMENTS.map((m) => (
              <div key={m.label} className="flex items-center gap-2 px-4 py-2 glass rounded-sm">
                <m.icon size={14} className="text-[#F47A20]" strokeWidth={1.6} />
                <span className="serial text-[10px] text-white/80">{m.label}</span>
              </div>
            ))}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.15 }}
          className="lg:col-span-5"
        >
          <div className="grid grid-cols-2 gap-3">
            {/* Primary: John sketching in Greece with ROADRIG mug */}
            <div className="aspect-[3/4] overflow-hidden rounded-sm border border-white/10">
              <img
                src={IMG.GREECE_SKETCH}
                alt="John sketching OUTLAW concepts in Greece with a ROADRIG mug"
                style={{ objectPosition: "50% 30%" }}
                className="w-full h-full object-cover"
              />
            </div>
            {/* Secondary: cinematic coastal ride */}
            <div className="aspect-[3/4] overflow-hidden rounded-sm border border-white/10 mt-8">
              <img
                src={IMG.RIDE_COAST}
                alt="John riding the Road Glide along the Greek coast"
                style={{ objectPosition: "40% 50%" }}
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="mt-4 px-4 py-3 glass rounded-sm">
            <div className="serial text-[10px] text-[#F47A20] mb-1">FIELD NOTES</div>
            <p className="text-white/70 text-sm">
              Coffee, salt air, and a sketchbook. Half of OUTLAW V1 lives in those pages.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
